import { useNavigate } from 'react-router-dom';
import { Heading } from '@/components/ui/heading';
import { resolveMediaUrl } from '../ui/resolveMediaUrl';
import { resolveHeadingLevel } from '../ui/heading-level';
import { MediaSlider } from '../ui/media-slider';
import { MediaSliderCardBody } from '../ui/media-slider-card';
import type { ImageBlock } from './types';
import { brandifyJncquoi } from '@/lib/core';

interface SliderItem {
  nodeKey?: string | null;
  image?: ImageBlock | null;
  title?: string | null;
  description?: string | null;
}

interface VenueSliderBlockProps {
  title?: string | null;
  titleHeading?: string | null;
  items?: SliderItem[] | null;
}

export function VenueSliderBlock({ title, titleHeading, items }: VenueSliderBlockProps) {
  const navigate = useNavigate();
  const headingAs = resolveHeadingLevel(titleHeading);

  if (!items?.length) return null;

  return (
    <div className="flex flex-col gap-6 pb-2 pl-4">
      {title && (
        <Heading
          as={headingAs}
          className="font-pp-neue-montreal text-jncquoi-neutral-1000 text-[24px] leading-normal font-semibold"
        >
          {title}
        </Heading>
      )}

      <MediaSlider
        items={items}
        gapClassName="gap-2"
        gapPx={8}
        fallbackRatio={0.62}
        renderItem={(item, i, cardProps) => {
          const imageUrl = resolveMediaUrl(item.image?.url);
          return (
            <button
              key={i}
              type="button"
              disabled={!item.nodeKey}
              onClick={() => item.nodeKey && navigate(`/venue-detail/${item.nodeKey}`)}
              className="flex w-[62vw] shrink-0 snap-start flex-col gap-2 text-left"
              {...cardProps}
            >
              <MediaSliderCardBody
                imageUrl={imageUrl}
                imageAlt={item.title ?? ''}
                title={brandifyJncquoi(item.title?.toUpperCase() ?? '')}
                subtitle={item.description}
              />
            </button>
          );
        }}
      />
    </div>
  );
}
